export const Cidades = [
  'Abatiá',
  'Adrianópolis',
  'Agudos do Sul',
  'Almirante Tamandaré',
  'Altamira do Paraná',
  'Altônia',
  'Alto Paraná',
  'Alto Piquiri',
  'Alvorada do Sul',
  'Amaporã',
  'Ampére',
  'Anahy',
  'Andirá',
  'Ângulo',
  'Antonina',
  'Antônio Olinto',
  'Apucarana',
  'Arapongas',
  'Arapoti',
  'Arapuã',
  'Araruna',
  'Araucária',
  'Ariranha do Ivaí',
  'Assaí',
  'Assis Chateaubriand',
  'Astorga',
  'Atalaia',
  'Balsa Nova',
  'Bandeirantes',
  'Barbosa Ferraz',
  'Barracão',
  'Barra do Jacaré',
  'Bela Vista da Caroba',
  'Bela Vista do Paraíso',
  'Bituruna',
  'Boa Esperança',
  'Boa Esperança do Iguaçu',
  'Boa Ventura de São Roque',
  'Boa Vista da Aparecida',
  'Bocaiúva do Sul',
  'Bom Jesus do Sul',
  'Bom Sucesso',
  'Bom Sucesso do Sul',
  'Borrazópolis',
  'Braganey',
  'Brasilândia do Sul',
  'Cafeara',
  'Cafelândia',
  'Cafezal do Sul',
  'Califórnia',
  'Cambará',
  'Cambé',
  'Cambira',
  'Campina da Lagoa',
  'Campina do Simão',
  'Campina Grande do Sul',
  'Campo Bonito',
  'Campo do Tenente',
  'Campo Largo',
  'Campo Magro',
  'Campo Mourão',
  'Cândido de Abreu',
  'Candói',
  'Cantagalo',
  'Capanema',
  'Capitão Leônidas Marques',
  'Carambeí',
  'Carlópolis',
  'Cascavel',
  'Castro',
  'Catanduvas',
  'Centenário do Sul',
  'Cerro Azul',
  'Céu Azul',
  'Chopinzinho',
  'Cianorte',
  'Cidade Gaúcha',
  'Clevelândia',
  'Colombo',
  'Colorado',
  'Congonhinhas',
  'Conselheiro Mairinck',
  'Contenda',
  'Corbélia',
  'Cornélio Procópio',
  'Coronel Domingos Soares',
  'Coronel Vivida',
  'Corumbataí do Sul',
  'Cruzeiro do Iguaçu',
  'Cruzeiro do Oeste',
  'Cruzeiro do Sul',
  'Cruz Machado',
  'Cruzmaltina',
  'Curitiba',
  'Curiúva',
  'Diamante do Norte',
  'Diamante do Sul',
  'Diamante D´oeste',
  'Dois Vizinhos',
  'Douradina',
  'Doutor Camargo',
  'Enéas Marques',
  'Engenheiro Beltrão',
  'Esperança Nova',
  'Entre Rios do Oeste',
  'Espigão Alto do Iguaçu',
  'Farol',
  'Faxinal',
  'Fazenda Rio Grande',
  'Fênix',
  'Fernandes Pinheiro',
  'Figueira',
  'Floraí',
  'Flor da Serra do Sul',
  'Floresta',
  'Florestópolis',
  'Flórida',
  'Formosa do Oeste',
  'Foz do Iguaçu',
  'Francisco Alves',
  'Francisco Beltrão',
  'Foz do Jordão',
  'General Carneiro',
  'Godoy Moreira',
  'Goioerê',
  'Goioxim',
  'Grandes Rios',
  'Guaíra',
  'Guairaçá',
  'Guamiranga',
  'Guapirama',
  'Guaporema',
  'Guaraci',
  'Guaraniaçu',
  'Guarapuava',
  'Guaraqueçaba',
  'Guaratuba',
  'Honório Serpa',
  'Ibaiti',
  'Ibema',
  'Ibiporã',
  'Icaraíma',
  'Iguaraçu',
  'Iguatu',
  'Imbaú',
  'Imbituva',
  'Inácio Martins',
  'Inajá',
  'Indianópolis',
  'Ipiranga',
  'Iporã',
  'Iracema do Oeste',
  'Irati',
  'Iretama',
  'Itaguajé',
  'Itaipulândia',
  'Itambaracá',
  'Itambé',
  'Itapejara D´oeste',
  'Itaperuçu',
  'Itaúna do Sul',
  'Ivaí',
  'Ivaiporã',
  'Ivaté',
  'Ivatuba',
  'Jaboti',
  'Jacarezinho',
  'Jaguapitã',
  'Jaguariaíva',
  'Jandaia do Sul',
  'Janiópolis',
  'Japira',
  'Japurá',
  'Jardim Alegre',
  'Jardim Olinda',
  'Jataizinho',
  'Jesuítas',
  'Joaquim Távora',
  'Jundiaí do Sul',
  'Juranda',
  'Jussara',
  'Kaloré',
  'Lapa',
  'Laranjal',
  'Laranjeiras do Sul',
  'Leópolis',
  'Lidianópolis',
  'Lindoeste',
  'Loanda',
  'Lobato',
  'Londrina',
  'Luiziana',
  'Lunardelli',
  'Lupionópolis',
  'Mallet',
  'Mamborê',
  'Mandaguaçu',
  'Mandaguari',
  'Mandirituba',
  'Manfrinópolis',
  'Mangueirinha',
  'Manoel Ribas',
  'Marechal Cândido Rondon',
  'Maria Helena',
  'Marialva',
  'Marilândia do Sul',
  'Marilena',
  'Mariluz',
  'Maringá',
  'Mariópolis',
  'Maripá',
  'Marmeleiro',
  'Marquinho',
  'Marumbi',
  'Matelândia',
  'Matinhos',
  'Mato Rico',
  'Mauá da Serra',
  'Medianeira',
  'Mercedes',
  'Mirador',
  'Miraselva',
  'Missal',
  'Moreira Sales',
  'Morretes',
  'Munhoz de Melo',
  'Nossa Senhora Das Graças',
  'Nova Aliança do Ivaí',
  'Nova América da Colina',
  'Nova Aurora',
  'Nova Cantu',
  'Nova Esperança',
  'Nova Esperança do Sudoeste',
  'Nova Fátima',
  'Nova Laranjeiras',
  'Nova Londrina',
  'Nova Olímpia',
  'Nova Santa Bárbara',
  'Nova Santa Rosa',
  'Nova Prata do Iguaçu',
  'Nova Tebas',
  'Novo Itacolomi',
  'Ortigueira',
  'Ourizona',
  'Ouro Verde do Oeste',
  'Paiçandu',
  'Palmas',
  'Palmeira',
  'Palmital',
  'Palotina',
  'Paraíso do Norte',
  'Paranacity',
  'Paranaguá',
  'Paranapoema',
  'Paranavaí',
  'Pato Bragado',
  'Pato Branco',
  'Paula Freitas',
  'Paulo Frontin',
  'Peabiru',
  'Perobal',
  'Pérola',
  'Pérola D´oeste',
  'Piên',
  'Pinhais',
  'Pinhalão',
  'Pinhal de São Bento',
  'Pinhão',
  'Piraí do Sul',
  'Piraquara',
  'Pitanga',
  'Pitangueiras',
  'Planaltina do Paraná',
  'Planalto',
  'Ponta Grossa',
  'Pontal do Paraná',
  'Porecatu',
  'Porto Amazonas',
  'Porto Barreiro',
  'Porto Rico',
  'Porto Vitória',
  'Prado Ferreira',
  'Pranchita',
  'Presidente Castelo Branco',
  'Primeiro de Maio',
  'Prudentópolis',
  'Quarto Centenário',
  'Quatiguá',
  'Quatro Barras',
  'Quatro Pontes',
  'Quedas do Iguaçu',
  'Querência do Norte',
  'Quinta do Sol',
  'Quitandinha',
  'Ramilândia',
  'Rancho Alegre',
  'Rancho Alegre D´oeste',
  'Realeza',
  'Rebouças',
  'Renascença',
  'Reserva',
  'Reserva do Iguaçu',
  'Ribeirão Claro',
  'Ribeirão do Pinhal',
  'Rio Azul',
  'Rio Bom',
  'Rio Bonito do Iguaçu',
  'Rio Branco do Ivaí',
  'Rio Branco do Sul',
  'Rio Negro',
  'Rolândia',
  'Roncador',
  'Rondon',
  'Rosário do Ivaí',
  'Sabáudia',
  'Salgado Filho',
  'Salto do Itararé',
  'Salto do Lontra',
  'Santa Amélia',
  'Santa Cecília do Pavão',
  'Santa Cruz de Monte Castelo',
  'Santa fé',
  'Santa Helena',
  'Santa Inês',
  'Santa Isabel do Ivaí',
  'Santa Izabel do Oeste',
  'Santa Lúcia',
  'Santa Maria do Oeste',
  'Santa Mariana',
  'Santa Mônica',
  'Santana do Itararé',
  'Santa Tereza do Oeste',
  'Santa Terezinha de Itaipu',
  'Santo Antônio da Platina',
  'Santo Antônio do Caiuá',
  'Santo Antônio do Paraíso',
  'Santo Antônio do Sudoeste',
  'Santo Inácio',
  'São Carlos do Ivaí',
  'São Jerônimo da Serra',
  'São João',
  'São João do Caiuá',
  'São João do Ivaí',
  'São João do Triunfo',
  'São Jorge D´oeste',
  'São Jorge do Ivaí',
  'São Jorge do Patrocínio',
  'São José da Boa Vista',
  'São José Das Palmeiras',
  'São José Dos Pinhais',
  'São Manoel do Paraná',
  'São Mateus do Sul',
  'São Miguel do Iguaçu',
  'São Pedro do Iguaçu',
  'São Pedro do Ivaí',
  'São Pedro do Paraná',
  'São Sebastião da Amoreira',
  'São Tomé',
  'Sapopema',
  'Sarandi',
  'Saudade do Iguaçu',
  'Sengés',
  'Serranópolis do Iguaçu',
  'Sertaneja',
  'Sertanópolis',
  'Siqueira Campos',
  'Sulina',
  'Tamarana',
  'Tamboara',
  'Tapejara',
  'Tapira',
  'Teixeira Soares',
  'Telêmaco Borba',
  'Terra Boa',
  'Terra Rica',
  'Terra Roxa',
  'Tibagi',
  'Tijucas do Sul',
  'Toledo',
  'Tomazina',
  'Três Barras do Paraná',
  'Tunas do Paraná',
  'Tuneiras do Oeste',
  'Tupãssi',
  'Turvo',
  'Ubiratã',
  'Umuarama',
  'União da Vitória',
  'Uniflor',
  'Uraí',
  'Wenceslau Braz',
  'Ventania',
  'Vera Cruz do Oeste',
  'Verê',
  'Alto Paraíso',
  'Doutor Ulysses',
  'Virmond',
  'Vitorino',
  'Xambrê',
];
